import { render, staticRenderFns } from "./SalesMonitoring.vue?vue&type=template&id=ebfec72a&"
import script from "./SalesMonitoring.vue?vue&type=script&lang=js&"
export * from "./SalesMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./SalesMonitoring.vue?vue&type=style&index=0&id=ebfec72a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports